import { ApolloClient, ApolloError } from "@apollo/client"
import { FormikErrors } from "formik"
import { CHECK_FILE_NAME } from "../../../queries/CHECK_FILE_NAME"
import { BatchItem } from "../BatchItem"
import { FormValues, ValidationErrorMessages } from "./interfaces"
import { isDuplicateName } from "./ValidationHelpers"
import {
    fileNameExistsValidationSchema,
    sourceTextValidationSchema,
    targetTextValidationSchema
} from "./ValidationSchemas"

export interface InitialErrors {
    [index: number]: FormikErrors<FormValues>
}
export class BatchItemValidator {
    constructor(private client: ApolloClient<object>) {}

    async validate(items: BatchItem[]): Promise<InitialErrors> {
        const errors: InitialErrors = {}

        items.forEach(async item => {
            const itemErrors: FormikErrors<FormValues> = {}

            await sourceTextValidationSchema
                .validate(item.source)
                .catch(e => (itemErrors.source = e.message))

            await targetTextValidationSchema
                .validate(item.target)
                .catch(e => (itemErrors.target = e.message))

            await fileNameExistsValidationSchema
                .validate(item.name)
                .catch(e => (itemErrors.name = e.message))

            if (isDuplicateName(item.name, item, items))
                itemErrors.name = ValidationErrorMessages.DUPLICATE_FILE_NAME

            errors[item.index] = itemErrors
        })

        const queries = items.map((item: any) => {
            return this.client
                .query({
                    variables: { checkFileNameInput: { fileName: item.name } },
                    query: CHECK_FILE_NAME,
                    fetchPolicy: "network-only"
                })
                .catch((err: ApolloError) => {
                    errors[item.index] = { ...errors[item.index], name: err.message }
                })
        })

        await Promise.all(queries)
        return errors
    }
}
